import { nextMonthUtc, todayUtc, transformDateToUtc, getReadableDate } from './DateService';
import { reactive } from "vue";
import { CalendarData } from "@/interfaces/calendar.interface";

export const CalendarState = {
    state:reactive({
        chartOptions: {
            title: {
                text: ''
            },
            chart: {
                type: 'xrange',
                zoomType: 'xy',
                styledMode: false,
                height:340,
                scrollablePlotArea: {
                    minWidth: 1400,
                    scrollPositionX: 0,
                }
            } as any,
            xAxis: {
                type: 'datetime',
                opposite: true,
                
                tickInterval: 24 * 3600 * 1000 * 2
                // scrollbar: {
                //     enabled: true
                // }
            },
            yAxis: {
                title: {
                    text: ''
                },
                categories: [] as string[],
                reversed: true,
                min: 0,
                max: 1,
                scrollbar: {
                    enabled: true,
                    showFull: true
                },
            },
            tooltip: {
                crosshairs: true,
                useHTML: true,
                backgroundColor: '#fff',
                borderColor: 'black',
                borderRadius: 8,
                borderWidth: 0,
                zIndex: 11,
                // headerFormat: '<table><tr><th colspan="2">{point.text}</th></tr>',
                // pointFormat: '<tr><td style="color: {point.color}">{series.name} {point.y}</td>',
                pointFormat: '<div class="flex-column-start"><h6 class="tooltip-text">{point.text}</h6><h6 class="tooltip-text">Apartment: {point.apartment}</h6><h6 class="tooltip-text">Amount to pay: {point.amountToPay}</h6><h6 class="tooltip-text">Days: {point.days}</h6></div>',

            },
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    borderRadius: 10,
                    point: {
                        events: {
                            click: function () {
                            }
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        inside: true,
                        color: 'white',
                        style: {
                            textOutline: 'none'
                        }
                    }
                }
            },
            series: [
                {
                    name: 'Apartment',
                    dataLabels: [{
                        align: 'center',
                        format: '{point.text}   {point.days} days',
                        style: {
                            textOutline: 'none'
                        }
                    }],
                    pointWidth: 20,
                    data: [

                    ] as CalendarData[],

                }],

        }
    })
}

export function addCalendarProps(x1Date:any, x2Date:any, categories:string[], color:string, text:string, amount:number, apartment:string) {
    const newPropsObj = {
        x: transformDateToUtc(x1Date),
        x2: transformDateToUtc(x2Date),
        y: categories.indexOf(apartment),
        color: color,
        text: text,
        amountToPay: amount,
        apartment: apartment,
        days: Math.floor((transformDateToUtc(x2Date) - transformDateToUtc(x1Date)) / 86400000),
        startDate:getReadableDate(x1Date),
        endDate:getReadableDate(x2Date),
        minPointLength: 20,
    } as CalendarData;
    return newPropsObj;
}